import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import type { GraphQLEmployee } from 'modules/org_chart/lib/employeeUtils'

import DirectReports from './DirectReports'
import Overview from './Overview'

const ReportsDetails = ({
  allEmployees,
  employeeMap,
}: {
  allEmployees: GraphQLEmployee[]
  employeeMap: Map<number, GraphQLEmployee>
}) => {
  return (
    <Box>
      <Overview allEmployees={allEmployees} />

      <DirectReports allEmployees={allEmployees} />
    </Box>
  )
}

export default ReportsDetails
